const upload ="/common/file/fragmentUpload";
const del ="/common/file/del";
const chatGpt ="/common/chatGpt";
const aesOperate="/common/aes/operate";
//const webSocket="wss://api-monitor.mymhp.cn/socket/connect?clientId=";
const webSocket="ws://127.0.0.1:7777/socket/connect?clientId=";
export default {
    upload,del,webSocket,chatGpt,aesOperate
  }